export const ID_NAME_MAPPING = {
  4: {
    title: "Rinkeby Network",
    name: "BSCMAIN"
  },
  5: {
    title: "Goerli Network",
    name: "GOERLI"
  },
  1: {
    title: "Ethereum Network",
    name: "HOMESTEAD"
  }
};

export const NAME_ID_MAPPING = {
  GOERLI: {
    title: "Goerli Network",
    id: 5
  },
  HOMESTEAD: {
    title: "Ethereum Network",
    id: 1
  }
};
